/********** YOSHIKI TEST **********/
  $(document).ready(function(){
    $('body').addClass('yoshiki');
  });
/********** /YOSHIKI TEST **********/